import { render } from "./KuponJajanA1de.vue?vue&type=template&id=1734f85d"
import script from "./KuponJajanA1de.vue?vue&type=script&lang=js"
export * from "./KuponJajanA1de.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__